import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/content';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-5 py-3.5 text-sm';
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-3 rounded-full bg-wine font-sans font-semibold uppercase tracking-wide text-ivory shadow-[0_10px_30px_-12px_rgba(112,31,40,0.7)] transition-[background-color,transform,box-shadow] duration-150 ease-smooth hover:bg-wine-dark hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-wine active:translate-y-0 ${sizing} ${className}`} data-id="element-15" data-mp="qk20d4027gdy">
      <span className="text-center leading-tight" data-id="element-16" data-mp="157de9cjprch8">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-17" data-mp="35yhak7it5e7b" />
    </a>;
}